const scope = 'tableDropdown/';
export const SET_DROPDOWN_DATA = `${scope}SET_DROPDOWN_DATA`;
